module.exports = __webpack_public_path__ + "static/media/LandingPageVideo.471db09c.mp4";